import { ServerSideMetricsDetailByTime } from '@pubstack/common/src/analytics/query'
import { CurrencySymbol } from '@pubstack/common/src/currency'
import { Timezone } from '@pubstack/common/src/timezone'
import { DateTime } from 'luxon'
import { FunctionComponent } from 'react'
import { WidgetProps } from '~/components/Widget'
import { AnalyticsDefaultChartOptions } from '~/modules/analytics/AnalyticsCharts'
import { AnalyticsChartWidget } from '~/modules/analytics/AnalyticsChartWidget'
import { TimelineConfiguration, useTimelineChart } from '~/modules/analytics/analyticsTimeline.hooks'
import { serverSideImpressionRevenue } from '~/modules/analytics/common/formulas'
import { WithClassName } from '~/types/utils'
import { displayWithCurrency } from '~/utils/string'

const timelineConfiguration: TimelineConfiguration<ServerSideMetricsDetailByTime> = {
  getChartOptions: ({ currencySymbol }) => ({
    annotations: { ...AnalyticsDefaultChartOptions.annotations, style: 'point' },
    crosshair: { ...AnalyticsDefaultChartOptions.crosshair, trigger: 'both' },
    vAxis: { format: displayWithCurrency('#,###', currencySymbol), minValue: 0 },
  }),
  legendConfig: ['serverSideImpressionRevenue'],
  tooltipConfig: ['serverSideImpressionRevenue'],
  dataConfig: [
    {
      name: 'serverSideImpressionRevenue',
      isComputable: ({ data }) => serverSideImpressionRevenue.isComputable(data),
      getFormula: () => serverSideImpressionRevenue,
      iconName: 'data_line',
      withValue: true,
    },
  ],
}

type ServerSideWidgetRevenueProps = WithClassName &
  Omit<WidgetProps, 'title' | 'icon' | 'info' | 'refreshTrackingLabel'> & {
    data: ServerSideMetricsDetailByTime
    currencySymbol: CurrencySymbol
    currentEpoch: DateTime
    timezone: Timezone
  }
export const ServerSideWidgetRevenue: FunctionComponent<ServerSideWidgetRevenueProps> = ({ data, currencySymbol, currentEpoch, timezone, ...props }) => {
  const { chart, legends } = useTimelineChart({ currentConfig: timelineConfiguration, data, currencySymbol, currentEpoch, timezone })
  return (
    <AnalyticsChartWidget {...props} icon={'bidder'} title={'Revenue'} chart={chart} legends={legends} smallChart={true} refreshTrackingLabel={'ana-server-side-detail-revenue-timeline-refresh'} />
  )
}
